import {
  generateCustomForm,
  attachCustomFormTools,
} from "/WebInterface/new-ui/modules/custom-form/custom-form.js";
import Modal from "/WebInterface/new-ui/modules/modal.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import {
  getCustomForm,
  postCustomForm,
} from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import { validate } from "/WebInterface/new-ui/assets/js/utils/validate.js";

const WelcomeForm = (callback = () => {}) => {
  const handleOkButtonClick = (dialog) => {
    const validateFields = validate(dialog.root, false);
    if (validateFields.length === 0) {
      const messageFormLoader = new Loader({});
      const data = utils.formatFormDatesForApi(
        dialog.root,
        utils.serializeInputs(dialog.root)
      );
      postCustomForm({ ...data, meta_form_name: dialog.title })
        .then(() => {
          dialog.hide(true);
          callback();
        })
        .catch((error) => {
          console.log(error);
          growl(t("someThingWentWrong"), t("failure"), 5000, true);
        })
        .finally(() => {
          messageFormLoader.deleteLoader();
        });
    }
  };

  const showWelcomeForm = async (customForm) => {
    const isShowWelcomeFormAlways = customForm.always === "true";
    const formName = customForm.name;
    const loggedUsername = utils.storage.get("loggedUsername");
    const localStorageFormKey = `WELCOMEFORM_${loggedUsername}_${formName}`;

    if (utils.storage.get(localStorageFormKey) === null) {
      utils.storage.set(localStorageFormKey, true);
    }

    if (
      !isShowWelcomeFormAlways &&
      !JSON.parse(utils.storage.get(localStorageFormKey))
    ) {
      return;
    }

    utils.storage.set(localStorageFormKey, isShowWelcomeFormAlways);

    // Get form configuration from window.customFormSettings
    const config = window.customFormSettings?.[formName] || {};

    // Get width and height from config, with fallback to defaults
    const modalWidth = config.width
      ? typeof config.width === "number"
        ? `${config.width}px`
        : config.width
      : "800px";
    const modalHeight = config.height
      ? typeof config.height === "number"
        ? `${config.height}px`
        : config.height
      : "575px";

    const formContent = generateCustomForm(customForm);
    const welcomeDialog = new Modal({
      title: formName || "welcomeForm",
      body: formContent,
      hasCloseOption: false,
      closable: false,
      uniqueId: "welcome-form",
      minWidth: modalWidth,
      minHeight: modalHeight,
      buttons: [
        {
          label: "OK",
          close: false,
          classes: ["mr-3"],
          onClick: () => {
            handleOkButtonClick({
              ...welcomeDialog,
              title: formName || "welcomeForm",
            });
          },
        },
      ],
    });

    attachCustomFormTools(welcomeDialog.root, formName);
  };

  getCustomForm("messageForm")
    .then(showWelcomeForm)
    .catch((error) => {
      console.log(error);
    });
};

export default WelcomeForm;
